<footer class="hidden lg:block py-12 lg:py-16 bg-[#121826]" lang="es-HN">
  <div class="container mx-auto px-4 lg:px-8">
    <!-- Header Section -->
    <header class="text-center mb-12">
      <img
        src="/logos/version-white-red.webp"
        alt="Logo de Allas Repuestos"
        class="h-16 mx-auto mb-4"
        width="200"
        height="64"
        loading="eager"
      />
      <strong class="text-xl font-bold text-white">
        ¡Ayudamos a mover el mundo!
      </strong>
      <p class="text-gray-300 font-light mt-2 max-w-2xl mx-auto">
        Somos la empresa líder en repuestos automotrices en Honduras con más de
        35 años de experiencia.
      </p>
    </header>

    <!-- Navigation Sections -->
    <nav
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-6 mb-12"
      aria-label="Enlaces del pie de página"
    >
      <!-- Shopping Section -->
      <section>
        <h2 class="text-xl mb-4 text-white font-bold fs-condensed">COMPRAR</h2>
        <ul class="space-y-2" role="list">
          @for(item of shopping; track item.name) {
          <ng-container
            [ngTemplateOutlet]="footerLink"
            [ngTemplateOutletContext]="{ item: item }"
          ></ng-container>
          }
        </ul>
      </section>

      <!-- Products Section -->
      <section>
        <h2 class="text-xl mb-4 text-white font-bold fs-condensed">
          PRODUCTOS
        </h2>
        <ul class="space-y-2" role="list">
          @for(category of categories; track category.name) {
          <ng-container
            [ngTemplateOutlet]="footerLink"
            [ngTemplateOutletContext]="{ item: category }"
          ></ng-container>
          }
        </ul>
      </section>

      <!-- Services Section -->
      <section>
        <h2 class="text-xl mb-4 text-white font-bold fs-condensed">
          SERVICIOS
        </h2>
        <ul class="space-y-2" role="list">
          @for(service of services; track service.name) {
          <ng-container
            [ngTemplateOutlet]="footerLink"
            [ngTemplateOutletContext]="{ item: service }"
          ></ng-container>
          }
        </ul>
      </section>

      <!-- Company Section -->
      <section>
        <h2 class="text-xl mb-4 text-white font-bold fs-condensed">EMPRESA</h2>
        <ul class="space-y-2 mb-6" role="list">
          @for(link of company; track link.name) {
          <ng-container
            [ngTemplateOutlet]="footerLink"
            [ngTemplateOutletContext]="{ item: link }"
          ></ng-container>
          }
        </ul>
      </section>

      <!-- Help Section -->
      <section>
        <h2 class="text-xl mb-4 text-white font-bold fs-condensed">AYUDA</h2>
        <ul class="space-y-2" role="list">
          @for(link of customerService; track link.name) {
          <ng-container
            [ngTemplateOutlet]="footerLink"
            [ngTemplateOutletContext]="{ item: link }"
          ></ng-container>
          }
        </ul>

        <!-- Business Hours -->
        <div class="mt-4">
          <h3 class="text-gray-300 font-inter text-sm font-medium mb-2">
            Horarios:
          </h3>
          <p class="text-gray-300 font-inter text-sm">
            Lun-Vie: 8:00 AM - 5:00 PM
          </p>
          <p class="text-gray-300 font-inter text-sm">Sáb: 8:00 AM - 3:00 PM</p>
        </div>
      </section>
    </nav>

    <!-- Contact Information -->
    <section class="border-t border-gray-800 pt-8 pb-8">
      <div class="text-center flex flex-col">
        <strong class="text-xl mb-4 text-white font-bold fs-condensed">
          CONTÁCTANOS
        </strong>

        <div
          class="flex flex-wrap justify-center gap-16 text-sm text-gray-200 mb-6"
        >
          <ng-container
            [ngTemplateOutlet]="contactItem"
            [ngTemplateOutletContext]="{
              icon: '/allas-icons/whatsapp-outline.svg',
              alt: 'WhatsApp',
              text: 'WhatsApp: +504 2283-4540'
            }"
          ></ng-container>

          <ng-container
            [ngTemplateOutlet]="contactItem"
            [ngTemplateOutletContext]="{
              icon: '/allas-icons/phone-white.svg',
              alt: 'Teléfono',
              text: 'Contact Center: +504 2509-7350'
            }"
          ></ng-container>

          <ng-container
            [ngTemplateOutlet]="contactItem"
            [ngTemplateOutletContext]="{
              icon: '/allas-icons/email.svg',
              alt: 'Correo electrónico',
              text: 'servicioalcliente@allasrepuestos.com'
            }"
          ></ng-container>

          <ng-container
            [ngTemplateOutlet]="contactItem"
            [ngTemplateOutletContext]="{
              icon: '/allas-icons/store-new-white.svg',
              alt: 'Ubicación',
              text: 'Honduras - Centroamérica'
            }"
          ></ng-container>
        </div>
      </div>
    </section>
  </div>
</footer>

<!-- Templates -->
<ng-template #footerLink let-item="item">
  <li>
    <a
      [href]="item.href"
      class="hover:text-white transition-colors font-inter text-sm text-gray-300"
      [attr.aria-label]="item.name"
    >
      {{ item.name }}
    </a>
  </li>
</ng-template>

<ng-template #contactItem let-icon="icon" let-alt="alt" let-text="text">
  <div class="flex items-center space-x-2">
    <img
      [src]="icon"
      [alt]="alt"
      class="w-5 h-5"
      width="20"
      height="20"
      loading="lazy"
    />
    <span>{{ text }}</span>
  </div>
</ng-template>
